"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _customPropTypes = require("../helpers/customPropTypes");

require("./RawButton.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RawButton = function (_React$Component) {
  _inherits(RawButton, _React$Component);

  function RawButton(props) {
    _classCallCheck(this, RawButton);

    var _this = _possibleConstructorReturn(this, (RawButton.__proto__ || Object.getPrototypeOf(RawButton)).call(this, props));

    _this.handleKeyDown = function (event) {
      if (
      // Prevent the default action to stop scrolling when space is pressed
      event.key === " " && event.target.tagName !== "INPUT" ||
      // Prevent submitting forms in IE/Edge
      event.key === "Enter") {
        event.preventDefault();
      }
    };

    _this.handleKeyUp = function (event) {
      if (event.key === " " && event.target.tagName !== "INPUT") {
        // Prevent the default action to stop scrolling when space is pressed
        event.preventDefault();
      }
      if (_this.isDisabled || !_this.props.canPropagate && event.target !== _this.$rawButton) return;
      if (event.key === " " || event.key === "Enter") {
        // Redirect the event to mouse click to fix the issue that onOutsideClick never been called when only using keyboard
        _this.$rawButton.click();
      }
    };

    _this.handleRef = function ($node) {
      _this.$rawButton = $node;

      // TODO Implement forward ref in React 16 way https://reactjs.org/docs/forwarding-refs.html#forwarding-refs-to-dom-components
      _this.props.buttonRef($node);
    };

    _this.handleClick = function (event) {
      if (!_this.props.canPropagate) event.stopPropagation();
      if (!_this.isDisabled) _this.props.onClick(event);
    };

    _this.$rawButton = null;
    return _this;
  }

  // this is needed for the spacebar event,
  // react synthetic event can't prevent spacebar from scrolling the page.


  _createClass(RawButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.$rawButton) {
        var canPropagate = this.props.canPropagate;

        this.$rawButton.addEventListener("keydown", this.handleKeyDown, canPropagate);
        this.$rawButton.addEventListener("keyup", this.handleKeyUp, canPropagate);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.$rawButton) {
        this.$rawButton.removeEventListener("keydown", this.handleKeyDown);
        this.$rawButton.removeEventListener("keyup", this.handleKeyUp);
      }
    }

    //Deprecation of disabled prop

  }, {
    key: "render",
    value: function render() {
      /* eslint-disable no-unused-vars */
      /* Destructuring is used to isolate additional props in moreProps and pass them along to
         the button.  Some are not used by render() but are needed above – they must remain in
         this statement though to exclude them from moreProps.
      */
      var _props = this.props,
          ariaLabel = _props.ariaLabel,
          buttonRef = _props.buttonRef,
          canPropagate = _props.canPropagate,
          children = _props.children,
          className = _props.className,
          isDisabled = _props.isDisabled,
          disabled = _props.disabled,
          tabIndex = _props.tabIndex,
          moreProps = _objectWithoutProperties(_props, ["ariaLabel", "buttonRef", "canPropagate", "children", "className", "isDisabled", "disabled", "tabIndex"]);
      /* eslint-enable no-unused-vars */

      var classes = (0, _classnames2.default)(className, "aclui-raw-button", { "is-disabled": this.isDisabled });

      if (ariaLabel) moreProps["aria-label"] = ariaLabel;

      /* eslint-disable jsx-a11y/no-static-element-interactions */
      /* eslint-disable jsx-a11y/click-events-have-key-events */
      /* es-lint is disabled for this specific reasons:
        1. Click-events-have-key-events: we are not using React synthetic events because we can't
          deal with the event.stopPropagation of the spacebar and prevent scrolling the page when the user
          presses the space bar.
        2. no-static-element-interactions: It's highly recommended to not use DIV or SPAN for interactive
          elements but in this very specific case we are trying to isolate and mimic the button role
          for icon buttons, arrow icons, carets, and any other elements that are interactive but
          not a button. We are doing this because using a <button /> normally inherents css styling
          from frameworks such as bootstrap or foundation, so in this way we always have a
          fresh button with no style attached.
       */

      return _react2.default.createElement(
        "span",
        _extends({}, moreProps, {
          "aria-disabled": this.isDisabled,
          className: classes,
          onClick: this.handleClick,
          ref: this.handleRef,
          tabIndex: this.isDisabled ? -1 : tabIndex
        }),
        _react2.default.createElement(
          "span",
          { "data-qa-anchor": "aclui-raw-button__content", className: "aclui-raw-button__content" },
          children
        )
      );
      /* eslint-enable jsx-a11y/no-static-element-interactions */
      /* eslint-enable jsx-a11y/click-events-have-key-events */
    }
  }, {
    key: "isDisabled",
    get: function get() {
      var _props2 = this.props,
          disabled = _props2.disabled,
          isDisabled = _props2.isDisabled;


      if (typeof disabled === "undefined") {
        return isDisabled;
      }
      return isDisabled || disabled;
    }

    // this is not a React synthetic event


    // this is not a React synthetic event

  }]);

  return RawButton;
}(_react2.default.Component);

RawButton.propTypes = {
  ariaLabel: _propTypes.string,
  buttonRef: _propTypes.func,
  canPropagate: _propTypes.bool,
  children: _propTypes.node.isRequired,
  className: _propTypes.string,

  /** disabled is deprecated. Use isDisabled instead */
  disabled: (0, _customPropTypes.deprecated)("isDisabled"),
  isDisabled: _propTypes.bool,
  onClick: _propTypes.func.isRequired,
  tabIndex: _propTypes.number,
  role: _propTypes.string
};

RawButton.defaultProps = {
  ariaLabel: null,
  buttonRef: function buttonRef() {},
  canPropagate: false,
  className: null,
  isDisabled: false,
  onKeyDown: function onKeyDown() {},
  role: "button",
  tabIndex: 0
};

exports.default = RawButton;